import React from "react";
import { connect } from "react-redux";
import Badge from "@mui/material/Badge";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import { getUnreadTicketsCount } from "../../modules/ticket/ticketsRead/ticketsReadActions";
import { selectTicketItems } from "../../modules/ticket/ticketList/ticketListSlice";

const mapStateToProps = ({ tickets }) => ({
  tickets,
});

const AnnouncementIconWithBadge = (props) => {
  const { readTicketsIds } = props.tickets;
  const items = selectTicketItems({ tickets: props.tickets });
  const ticketIndicatorCount = getUnreadTicketsCount(
    items,
    readTicketsIds || [],
  );

  return ticketIndicatorCount ? (
    <Badge
      color="secondary"
      overlap="rectangular"
      badgeContent={Number(ticketIndicatorCount)}
    >
      <AnnouncementIcon />
    </Badge>
  ) : (
    <AnnouncementIcon />
  );
};

export default connect(mapStateToProps)(AnnouncementIconWithBadge);
